import { MealImageTag } from '@tovala/component-library'

import StarSharpIcon from 'components/common/icons/StarSharpIcon'

/**
 * The user's own rating, shown over a meal image. Pass onClick where the badge
 * should take them to their full review — it sits inside the meal card's own click
 * area, so it stops the click from also opening the details at the top.
 */
const MealRatingBadge = ({
  onClick,
  stars,
}: {
  onClick?: () => void
  stars?: number
}) => {
  const label =
    stars === undefined
      ? 'Your rating'
      : `Your rating: ${stars} ${stars === 1 ? 'star' : 'stars'}`

  const badge = (
    <MealImageTag>
      <span
        aria-hidden="true"
        className="flex items-center space-x-1 text-k/12_120 font-semibold"
      >
        <span className="flex items-center space-x-1 text-orange-2">
          {stars !== undefined && <span>{stars}</span>}
          <span className="h-[12.44px] w-[12.44px]">
            <StarSharpIcon />
          </span>
        </span>
        <span>Your rating</span>
      </span>

      <span className="sr-only">
        {onClick ? `${label}. See your review` : label}
      </span>
    </MealImageTag>
  )

  if (!onClick) {
    return badge
  }

  return (
    <button
      onClick={(event) => {
        event.stopPropagation()

        onClick()
      }}
      type="button"
    >
      {badge}
    </button>
  )
}

export default MealRatingBadge
